const FORM_INPUT_CLASS = 'form-control tw:rounded-lg! tw:border-gray-300! tw:py-2! tw:bg-white!'

export default FORM_INPUT_CLASS
